import { TRule } from '../../typings';
import { EDI_WHEEL_B2_STOCKLIST_RULESET } from '../edi-b2/stocklist';

export const HANKOOK_STOCKLIST_RULESET: TRule[] = [
  ...EDI_WHEEL_B2_STOCKLIST_RULESET,
];
